import {HalContext} from "@cm/hal/hal-context"
import {HalImage} from "@cm/hal/hal-image/index"
import {HalPaintable} from "@cm/hal/hal-paintable"
import {HalPainterImageBlitOptions} from "@cm/hal"
import {HalPainter} from "@cm/hal/hal-painter/index"
import {HalPainterImageBlitRef} from "@cm/hal/hal-ref"

export class HalPainterImageFinalConversion implements HalPainter {
    public convertToSrgb = false
    public gamma = 1.0

    static create(context: HalContext): HalPainterImageFinalConversion {
        return new HalPainterImageFinalConversion(context)
    }

    private constructor(readonly context: HalContext) {
        this.halPainterImageBlit = this.context.createHalPainterImageBlit(BLITTING_FUNCTION)
    }

    dispose(): void {
        if (!this.halPainterImageBlit) {
            throw new Error("HalPainterImageFinalConversion: Already disposed")
        }
        this.halPainterImageBlit.release()
        this.halPainterImageBlit = null
    }

    paint(target: HalPaintable, sourceImage: HalImage, options?: HalPainterImageBlitOptions) {
        if (!this.halPainterImageBlit) {
            throw new Error("HalPainterImageFinalConversion: Already disposed")
        }
        this.halPainterImageBlit.ref.paint({
            target,
            parameters: {
                u_applySrgb: {type: "int", value: this.convertToSrgb ? 1 : 0},
                u_gamma: {type: "float", value: this.gamma},
            },
            sourceImages: sourceImage,
            options,
        })
    }

    private halPainterImageBlit: HalPainterImageBlitRef | null
}

const BLITTING_FUNCTION = `
    uniform int u_applySrgb;
    uniform float u_gamma;

    float linearToSrgb(float x) {
        if (x <= 0.0) {
            return 0.0;
        }
        else if (x >= 1.0) {
            return 1.0;
        }
        else if (x < 0.0031308) {
            return x * 12.92;
        }
        else {
            return pow(x, 1.0 / 2.4) * 1.055 - 0.055;
        }
    }

    vec4 computeColor(ivec2 targetPixel, ivec2 sourcePixel, int lod, int addressMode) {
        vec4 color = texelFetch0(sourcePixel, addressMode);
        if (u_applySrgb != 0) {
            color.rgb = vec3(linearToSrgb(color.r), linearToSrgb(color.g), linearToSrgb(color.b));
        }
        if (u_gamma != 1.0) {
            color.rgb = pow(color.rgb, vec3(u_gamma));
        }
        return color;
    }
`
